export enum ShortOrLongDated {
    None = 'None',
    Short = 'Short',
    Long = 'Long',
}
